// extracted by mini-css-extract-plugin
export default {"needMapping":"Russtat-List_needMapping__3NDAM","noMapping":"Russtat-List_noMapping__CSbVl","input":"Russtat-List_input__jiLwE"};